import { RootState } from 'store/root-reducer';

export const getErrors = (state: RootState): any | null => state.admin.platforms.error;
export const getResult = (state: RootState): any | null => state.admin.platforms.result;
